export default "__VITE_ASSET__62d21344__"